import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

interface PreloaderProps {
  animating: boolean;
  showBackground?: boolean;
  showLogo?: boolean;
  children?: React.ReactNode;
}

const Preloader = ({ animating, showBackground = true, showLogo = true, children }: PreloaderProps) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  
  // Get SVG from window and validate it
  const getSvgLogo = () => {
    try {
      const svgContent = (window as any).pageLoaderSvg;
      if (!svgContent || typeof svgContent !== 'string') {
        return null;
      }
      
      // Basic validation - check if it looks like SVG content
      const trimmed = svgContent.trim();
      if (!trimmed.startsWith('<svg') || !trimmed.includes('</svg>')) {
        console.warn('Invalid SVG content detected for page loader');
        return null;
      }
      
      return svgContent;
    } catch (error) {
      console.warn('Error accessing page loader SVG:', error);
      return null;
    }
  };

  const svgLogo = getSvgLogo();

  return (
    <CSSTransition
      in={animating}
      nodeRef={nodeRef}
      timeout={300}
      classNames='fade'
      unmountOnExit
    >
      <div
        ref={nodeRef}
        className={`preloader ${showBackground ? 'preloader--background' : ''}`}
      >
        <div className='flex flex-col items-center'>
          {children}
          {showLogo && svgLogo ? (
            <div
              className='preloader__logo preloader__logo--svg'
              dangerouslySetInnerHTML={{ __html: svgLogo }}
            />
          ) : showLogo ? (
            <i className='preloader__logo icon-nere-logo-n' />
          ) : null}
        </div>
      </div>
    </CSSTransition>
  );
};

export default Preloader;
